import { Control, Controller, FieldValues, Path } from "react-hook-form";
import { StandardTextFieldProps } from "@mui/material/TextField/TextField";
import { TextField } from "@mui/material";
import React from "react";
import { textFieldDefaultProps } from "./TextFieldDefaultProps";

interface RHFTextFieldProps<TField extends FieldValues> extends StandardTextFieldProps {
  control: Control<TField>;
  name: Path<TField>;
}
export const RHFCellTextField = <TField extends FieldValues>({
  control,
  name,
  ...props
}: RHFTextFieldProps<TField>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
        <TextField
          {...props}
          {...textFieldDefaultProps}
          inputRef={ref}
          error={!!error}
          helperText={error?.message}
          InputLabelProps={{
            shrink: true,
          }}
          value={value}
          onChange={(event) => {
            const newData = event.target.value;
            onChange(newData);
          }}
        />
      )}
    />
  );
};
